import request from '@/config/axios'

export interface AreaAgentUserVO {
  id?: number
  userId?: number
  nickname?: string
  avatar?: string
  mobile?: string
  agentType?: number
  agentTypeName?: string
  areaIdList?: number[]
  areaNames?: string
  levelId?: number
  levelName?: string
  status?: number
  applyTime?: string
  auditTime?: string
  auditReason?: string
  becomeTime?: string
  totalBonus?: number
  withdrawBonus?: number
  freezeBonus?: number
  createTime?: string
}

export const getAreaAgentUserPage = async (params: any) => {
  return await request.get({ url: '/trade/area-agent/user/page', params })
}

export const getAreaAgentUser = async (id: number) => {
  return await request.get({ url: '/trade/area-agent/user/get', params: { id } })
}

export const createAreaAgentUser = async (data: {
  userId: number
  agentType: number
  areaIds: number[]
  levelId?: number
}) => {
  return await request.post({ url: '/trade/area-agent/user/create', data })
}

export const auditAreaAgentUser = async (data: {
  id: number
  approved: boolean
  auditReason?: string
}) => {
  return await request.put({ url: '/trade/area-agent/user/audit', data })
}

export const updateAreaAgentUserStatus = async (data: { id: number; status: number }) => {
  return await request.put({ url: '/trade/area-agent/user/update-status', data })
}

export const updateAreaAgentUserLevel = async (data: { id: number; levelId: number }) => {
  return await request.put({ url: '/trade/area-agent/user/update-level', data })
}

export const completeAreaAgentUserArea = async (data: {
  id: number
  agentType: number
  areaIds: number[]
}) => {
  return await request.put({ url: '/trade/area-agent/user/complete-area', data })
}

export const checkAreaAgentAreaConflict = async (data: {
  excludeId?: number
  agentType: number
  areaIds: number[]
}) => {
  return await request.post({ url: '/trade/area-agent/user/check-area-conflict', data })
}
